export const FIXED_WEEKLY_PLAN = [
    {
        day_name: "Monday",
        focus_area: "Chest / Triceps",
        categories: [
            {
                name: "Chest",
                exercises: [
                    "Dumbbell Bench Press", "Push-ups", "Chest Fly", "Incline Dumbbell Bench Press",
                    "Decline Push-ups", "Shoulder Taps", "Banded Chest Press", "Isometric Wall Press"
                ]
            },
            {
                name: "Triceps",
                exercises: [
                    "Bench Dips", "Dumbbell Triceps Extension", "Reverse Grip Bench Press",
                    "Reverse Grip Triceps Pushdown", "Skull Crushers", "Tricep Rope Pushdown", "Tricep Press Machine"
                ]
            }
        ]
    },
    {
        day_name: "Tuesday",
        focus_area: "Back / Bicep",
        categories: [
            {
                name: "Back",
                exercises: [
                    "Bent Over Barbell Row", "Pendlay Row", "Gorilla Rows", "Pull Ups",
                    "Deadlifts", "Renegade Row", "Dumbbell Shrugs", "T-Bar Rows"
                ]
            },
            {
                name: "Biceps",
                exercises: [
                    "Concentration Curls", "Hammer Curls", "EZ Bar Curls", "Preacher Curl", "Single Arm High Cable Curl"
                ]
            }
        ]
    },
    {
        day_name: "Wednesday",
        focus_area: "Abs / Shoulder / Forearms",
        categories: [
            {
                name: "Abs",
                exercises: [
                    "Plank", "Hanging Leg Raises", "Bicycle Crunches", "Ab Wheel Rollouts",
                    "Russian Twists", "Reverse Crunches", "Mountain Climbers", "Dead Bug"
                ]
            },
            {
                name: "Shoulders",
                exercises: [
                    "Barbell Overhead Press", "Dumbbell Shoulder Press", "Arnold Press", "Lateral Raises",
                    "Front Raises", "Face Pulls", "Rear Delt Fly", "Upright Rows", "Pike Push-ups"
                ]
            },
            {
                name: "Forearms",
                exercises: [
                    "Wrist Curls", "Reverse Wrist Curls", "Farmer Walks", "Plate Pinches"
                ]
            }
        ]
    },
    {
        day_name: "Thursday",
        focus_area: "Chest / Tricep",
        categories: [
            {
                name: "Chest",
                exercises: [
                    "Dumbbell Bench Press", "Push-ups", "Chest Fly", "Incline Dumbbell Bench Press",
                    "Decline Push-ups", "Shoulder Taps", "Banded Chest Press", "Isometric Wall Press"
                ]
            },
            {
                name: "Triceps",
                exercises: [
                    "Bench Dips", "Dumbbell Triceps Extension", "Reverse Grip Bench Press",
                    "Reverse Grip Triceps Pushdown", "Skull Crushers", "Tricep Rope Pushdown", "Tricep Press Machine"
                ]
            }
        ]
    },
    {
        day_name: "Friday",
        focus_area: "Back / Bicep",
        categories: [
            {
                name: "Back",
                exercises: [
                    "Bent Over Barbell Row", "Pendlay Row", "Gorilla Rows", "Pull Ups",
                    "Deadlifts", "Renegade Row", "Dumbbell Shrugs", "T-Bar Rows"
                ]
            },
            {
                name: "Biceps",
                exercises: [
                    "Concentration Curls", "Hammer Curls", "EZ Bar Curls", "Preacher Curl", "Single Arm High Cable Curl"
                ]
            }
        ]
    },
    {
        day_name: "Saturday",
        focus_area: "Legs / Shoulder",
        categories: [
            {
                name: "Legs",
                exercises: [
                    "Squats", "Deadlifts", "Bridges", "Donkey Kicks",
                    "Hip Abduction", "Sumo Squats", "Lunges", "Bulgarian Split Squat"
                ]
            },
            {
                name: "Shoulders",
                exercises: [
                    "Barbell Overhead Press", "Dumbbell Shoulder Press", "Arnold Press", "Lateral Raises"
                ]
            }
        ]
    },
    {
        day_name: "Sunday",
        focus_area: "REST",
        categories: []
    }
];
